import React, { useState, useEffect, createRef } from "react";
// import logo from "../../assets/images/buscar-logo-light-2.png";
import logo from "../../assets/images/tcr-logo-light-2.png";
import { CheckCircle } from "react-feather";
import { useHistory, useParams, Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { validateEmail } from "../../utils/validate";
import { resetPasswordRequest, forgotPasswordRequest } from "../../api";
import "./styles.scss";

const ForgotPassword = () => {
  const { token } = useParams();
  if (token) {
    // POST to /users/reset_password
    return <ResetPassword token={token} />;
  } else {
    // POST to /users/forgot_password
    return <RequestPasswordReset />;
  }
};

function ResetPassword({ token }) {
  const { formatMessage: f } = useIntl();
  const passwordInput = createRef();

  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [passwordResetSucess, setPasswordResetSuccess] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    passwordInput.current && passwordInput.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    setErrorMessage(null);

    if (password.length === 0 || passwordInput.current.value !== password) {
      setErrorMessage(f({ id: "senhas-diferentes" }));
      return false;
    }

    setIsLoading(true);
    resetPasswordRequest(token, password)
      .then(() => {
        setPasswordResetSuccess(true);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message || f({ id: "erro-api" }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="logo has-title">
        <a href = "/">
          <img alt="BusCAR logo" src={logo} />
        </a>
        <div className="auth-title">{f({ id: "redefinir-senha" })}</div>
      </div>
      {errorMessage ? (
        <div className="auth-error-message">{errorMessage}</div>
      ) : (
        <div className="auth-error-message-spacer"></div>
      )}
      {passwordResetSucess ? (
        <>
          <div className="successful-request">
            <CheckCircle className="check" size="32px" />
            <p>{f({ id: "senha-redefinida-sucesso" })}.</p>
          </div>
          <div className="links">
            <Link to="/login">{f({ id: "entrar" })}</Link>
          </div>
        </>
      ) : (
        <>
          <input
            ref={passwordInput}
            type="password"
            name="password"
            placeholder={f({ id: "senha" })}
            required
          />
          <input
            type="password"
            name="password-confirmation"
            placeholder={f({ id: "confirma-senha" })}
            required
            onChange={e => setPassword(e.target.value)}
          />
          <button
            className={`button primary ${isLoading ? "is-loading" : ""}`}
            onClick={handleSubmit}
          >
            {f({ id: "enviar" })}
          </button>
        </>
      )}
    </>
  );
}

function RequestPasswordReset() {
  const history = useHistory();
  const { formatMessage: f } = useIntl();

  const [email, setEmail] = useState("");
  const [isSent, setIsSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let emailInput = createRef();

  useEffect(() => {
    emailInput.current && emailInput.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setErrorMessage(f({ id: "email-invalido" }));
      return false;
    }
    setIsLoading(true);
    forgotPasswordRequest(email)
      .then(() => {
        setIsSent(true);
      })
      .catch(error => {
        setErrorMessage(error.response.data.message || f({ id: "erro-api" }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="logo has-title">
        <a href = "/">
          <img alt="BusCAR logo" src={logo} />
        </a>
        <div className="auth-title">{f({ id: "redefinir-senha" })}</div>
      </div>
      {!!isSent && (
        <div className="successful-request">
          <CheckCircle className="check" size="32px" />
          <p>{f({ id: "verifique-seu-email" })}.</p>
        </div>
      )}
      {!!!isSent && (
        <>
          {errorMessage ? (
            <div className="auth-error-message">{errorMessage}</div>
          ) : (
            <div className="auth-error-message-spacer"></div>
          )}

          <div className="input-container">
            <input
              ref={emailInput}
              type="email"
              name="email"
              placeholder="E-mail"
              required
              onChange={e => setEmail(e.target.value)}
            />
            <label htmlFor="email">E-mail</label>
          </div>

          <button
            className={`button primary ${isLoading ? "is-loading" : ""}`}
            onClick={handleSubmit}
          >
            {f({ id: "enviar" })}
          </button>
          <div className="links">
            <a href="/#" onClick={() => history.goBack()}>
              {f({ id: "voltar" })}
            </a>
          </div>
        </>
      )}
    </>
  );
}

export default ForgotPassword;
